import { render, staticRenderFns } from "./ShopProduct.vue?vue&type=template&id=2dea0890&scoped=true"
import script from "./ShopProduct.vue?vue&type=script&lang=js"
export * from "./ShopProduct.vue?vue&type=script&lang=js"
import style0 from "./ShopProduct.vue?vue&type=style&index=0&id=2dea0890&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dea0890",
  null
  
)

export default component.exports